import React, { useState } from "react";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import { autoTable } from "jspdf-autotable";
// import "jspdf-autotable";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
const TableExporterImporter = ({
  data,
  // all data
  currentPageData, // only current visible page data

  onDataChange,
  menuStyle = {},
  Pagetitle,
  disableImport = false,
}) => {
  const [importedData, setImportedData] = useState([]);
  const [pdfFile, setPdfFile] = useState(null);
  const [importFormat, setImportFormat] = useState("");
  const [exportFormat, setExportFormat] = useState("");
  const [exportScope, setExportScope] = useState("all"); // 'page' or 'all'

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (importFormat === "excel") {
        readExcelFile(file);
      } else if (importFormat === "pdf") {
        handlePdfUpload(file);
      }
    }
  };

  const exportData = () => {
    const dataset = exportScope === "page" ? currentPageData || [] : data || [];
    console.log("exportScope", exportScope);
    console.log("currentPageData", currentPageData);
    console.log("data", data);
    console.log("dataset", dataset);

    if (dataset.length === 0) {
      toast.error("No data available to export.");
      return;
    }

    if (exportFormat === "excel") {
      exportToExcel(dataset, Pagetitle);
      toast.success("Data exported successfully as Excel!");
    } else if (exportFormat === "pdf") {
      exportToPDF(dataset, Pagetitle);
      toast.success("Data exported successfully as PDF!");
    } else {
      toast.error("Please select an export format.");
    }
  };

  // Export Data to Excel
  const exportToExcel = (data, pageTitle) => {
    const safeData = Array.isArray(data) ? data : [data];

    if (safeData.length === 0) {
      toast.error("No data available to export.");
      return;
    }

    const ws = XLSX.utils.json_to_sheet(safeData);

    const wb = XLSX.utils.book_new(); // Create a new workbook
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1"); // Append the sheet to the workbook
    const currentDate = new Date().toISOString().split("T")[0]; // "YYYY-MM-DD" format

    // Create the dynamic title combining PageTitle and Date
    const title = `${pageTitle} - ${currentDate}`;
    // Use pageTitle for the dynamic file name
    const fileName = `${title}.xlsx`; // Dynamic file name with page title

    // Export the Excel file with the dynamic file name
    XLSX.writeFile(wb, fileName);
  };
  // Export Data to PDF
  // const exportToPDF = (content, fileName) => {
  //   const doc = new jsPDF();
  //   doc.text(content, 10, 10);
  //   doc.save(fileName);
  // };
  const exportToPDF = (data, pageTitle) => {
    const doc = new jsPDF("l", "mm", "a4"); // 'l' for landscape orientation, 'a4' paper size

    // Format the current date (e.g., "YYYY-MM-DD")
    const currentDate = new Date().toISOString().split("T")[0]; // "YYYY-MM-DD" format

    // Create the dynamic title combining PageTitle and Date
    const title = `${pageTitle} - ${currentDate}`;
    doc.text(title, 10, 10); // Add the dynamic title to the top

    // Define the headers dynamically based on the keys of the data objects
    const headers = Object.keys(data[0]).map(
      (key) => key.charAt(0).toUpperCase() + key.slice(1) // Capitalize headers
    );

    // Prepare the rows for the table dynamically from the `data` prop
    const rows = data?.map((item) => Object.values(item)); // Extract the values from each row

    // Calculate the column width dynamically based on the page width
    const pageWidth = doc.internal.pageSize.getWidth();
    const columnWidth = (pageWidth - 20) / headers.length; // Adjust column width based on the number of columns

    // Generate columnStyles dynamically based on the number of columns
    const columnStyles = headers.reduce((styles, _, index) => {
      styles[index] = { cellWidth: columnWidth }; // Set each column's width dynamically
      return styles;
    }, {});

    // Use autoTable to add the table to the PDF
    autoTable(doc, {
      head: [headers], // Column headers
      body: rows, // Data rows
      startY: 20, // Start after the title
      margin: { top: 20, left: 10 },
      columnStyles: columnStyles, // Apply dynamic column styles
      styles: {
        fontSize: 8, // Smaller font size for long content
        overflow: "linebreak", // Ensure text is wrapped within cells
        cellPadding: 2, // Adjust cell padding
        columnWidth: "auto", // Set automatic column width for better wrapping
        textColor: "#333", // Darker text color for contrast
      },
      headStyles: {
        fontSize: 9, // Slightly larger font size for headers
        textColor: "#FFFFFF", // White text for headers
        fillColor: "#2E4053", // Background color for header
      },
      bodyStyles: {
        fontSize: 8, // Smaller font size for body text
        textColor: "#333", // Body text color
        lineWidth: 0.5, // Thin lines for better readability
      },
      margin: { top: 30 }, // Adjust the margin to make the table fit better on the page
    });

    // Save the PDF with the dynamic title (PageTitle + Date) as filename
    const filename = `${pageTitle} - ${currentDate}.pdf`; // For example: "ExportedData - 2025-04-27.pdf"
    doc.save(filename); // Save the file with dynamic name
  };

  // Handle File Upload for Excel
  const readExcelFile = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);
      setImportedData(jsonData);
      onDataChange(jsonData);
      toast.success("Excel file imported successfully!");
    };
    reader.readAsArrayBuffer(file);
  };

  return (
    <div className="container mx-auto p-16 bg-[#fff5fb]">
      <ToastContainer />

      <div
        className="flex flex-col md:flex-row justify-between mb-5 space-y-4 md:space-y-0 md:space-x-4 bg-[#fff5fb]"
        style={disableImport ? { display: "flex" } : {}}
      >
        {/* Import Format Dropdown */}
        {!disableImport && (
          <input
            style={{
              width: "35%", // Full width
              maxWidth: "50%", // Width for medium screens
              borderRadius: "0.5rem", // rounded-lg
              padding: "0.5rem", // p-2
              outline: "none", // focus:outline-none
              backgroundColor: "#2E4053", // bg-[#E5D8CF]
              appearance: "none", // appearance-none
              color: "#FFFFFF",
              boxShadow: "0 0 0 2px rgba(255, 255, 255, 0)", // To mimic focus:ring-2
              marginRight: "10px",
            }}
            type="file"
            onChange={handleFileUpload}
            accept={importFormat === "excel" ? ".xlsx" : ".pdf"}
          />
        )}
        {/* Export Format Dropdown */}
        <select
          style={{
            width: disableImport ? "65%" : "20%", // Full width
            maxWidth: disableImport ? "65%" : "50%", // Width for medium screens
            borderRadius: "0.5rem", // rounded-lg
            padding: "0.5rem", // p-2
            outline: "none", // focus:outline-none
            backgroundColor: "#2E4053", // bg-[#E5D8CF]
            color: "#FFFFFF", // text-[#333]
            appearance: "none", // appearance-none
            boxShadow: "0 0 0 2px rgba(255, 255, 255, 0)", // To mimic focus:ring-2
            marginRight: "10px",
          }}
          value={exportFormat}
          onChange={(e) => setExportFormat(e.target.value)}
          MenuProps={{
            PaperProps: {
              style: {
                backgroundColor: "#2E4053",
                ...menuStyle,
              },
            },
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = "#FFFFFF"; // Change background to white
            e.currentTarget.style.color = "#FFFFFF"; // Change text color to black
          }} // hover:bg-blue-600
          onMouseOut={(e) =>
            (e.currentTarget.style.backgroundColor = "#2E4053")
          }
        >
          <option value="" disabled>
            Select Export Format
          </option>
          <option value="excel">Excel (.xlsx)</option>
          <option value="pdf">PDF (.pdf)</option>
        </select>
        <select
          style={{
            width: "20%",
            borderRadius: "0.5rem",
            padding: "0.5rem",
            outline: "none",
            backgroundColor: "#2E4053",
            color: "#FFFFFF",
            marginRight: "10px",
          }}
          value={exportScope}
          onChange={(e) => setExportScope(e.target.value)}
        >
          <option value="all">All Pages</option>
          <option value="page">Current Page</option>
        </select>

        <button
          style={{
            width: disableImport ? "26%" : "13%", // Full width
            maxWidth: "50%", // Width for medium screens
            backgroundColor: "#2E4053", // bg-[#E5D8CF]
            color: "#FFFFFF", // text-white
            padding: "0.5rem ", // py-2 px-4
            borderRadius: "0.5rem", // rounded-lg
            transition: "background-color 0.3s",
            marginRight: "10px",
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = "#FFFFFF"; // Change background to white
            e.currentTarget.style.color = "#FFFFFF"; // Change text color to black
          }} // hover:bg-blue-600
          onMouseOut={(e) =>
            (e.currentTarget.style.backgroundColor = "#2E4053")
          } // revert to bg-blue-500
          onClick={exportData}
        >
          Export
        </button>
      </div>

      {/* <div className="mb-5">
        <h4 className="font-semibold mb-2 text-[#333]">Imported Data:</h4>
        <pre className="bg-white p-2 border rounded">
          {JSON.stringify(importedData, null, 2)}
        </pre>
      </div> */}
    </div>
  );
};

export default TableExporterImporter;
